import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import Navbar from "./Navbar";
import Footer from "./Footer";
import { Toaster } from "./ui/sonner";
import Seo from "./Seo";

import { fetchCategories } from "../lib/api";
import { buildStaticPageSchemas, getStaticPageSeo } from "../lib/seo";

export default function SiteLayout() {
  const location = useLocation();
  const [categories, setCategories] = useState([]);
  const isAdminRoute = location.pathname.startsWith("/admin");
  const isProductDetailRoute = location.pathname.startsWith("/products/");
  const pageSeo = getStaticPageSeo(location.pathname);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const data = await fetchCategories();
        setCategories(data);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    };

    loadCategories();
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-background">
      {!isProductDetailRoute && (
        <Seo
          title={pageSeo.title}
          description={pageSeo.description}
          canonicalPath={location.pathname}
          image={pageSeo.image}
          keywords={pageSeo.keywords}
          type={pageSeo.type}
          noindex={isAdminRoute}
          schema={isAdminRoute ? [] : buildStaticPageSchemas(location.pathname, pageSeo)}
        />
      )}

      {!isAdminRoute && <Navbar categories={categories} />}

      <main className="flex-1">
        <Outlet context={{ categories }} />
      </main>

      {!isAdminRoute && <Footer />}

      <Toaster
        position="bottom-right"
        duration={4000}
        richColors
        closeButton
      />
    </div>
  );
}